import React, { Component } from "react";
import Desplegable from "../../desplegable";
import VistaDatosSacramentales from "../vistas/vista_sacramental";
import FormDatosSacramentales from "../formularios/form_sacramentales";

export default class DesplegableSacramental extends Component {
  render() {
    return (
      <Desplegable
        eventKey="7"
        id="7"
        Toogle={"Datos Sacramentos"}
        showModal={this.props.state.showModalMatrix[7]}
        handleButtonShow={this.props.handleButtonShow}
        Text={
          <VistaDatosSacramentales
            DatosMonja={this.props.state.DatosUsuario} // En ese caso lo pasamo como datos monja
          ></VistaDatosSacramentales>
        }
        Form={
          <FormDatosSacramentales
            DatosMonja={this.props.state.DatosUsuario}
            setDatosHermana={this.props.setDatosHermana}
            handleButtonShow={this.props.handleButtonShow}
            setAlert={this.props.setAlert}
            ErrorHandling={this.props.ErrorHandling}
          ></FormDatosSacramentales>
        }
        canEdit={true}
      />
    );
  }
}
